import React, { useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'

type WithChildren<T = {}> = T & { children?: React.ReactNode }

export const Portal = ({ children }: WithChildren) => {
    let modalRoot = document.getElementById('modal')

    const elRef = useRef<HTMLDivElement | null>(null)
    if (!elRef.current) {
        elRef.current = document.createElement('div')
    }
    const modalElement = elRef.current

    if (!modalRoot) {
        modalRoot = document.createElement('div')
        modalRoot.setAttribute('id', 'modal')
        document.body.appendChild(modalRoot)
    }

    useEffect(() => {
        modalRoot?.appendChild(modalElement)
        return () => { 
            modalRoot?.removeChild(modalElement)
        }
    })

    return createPortal(children, modalElement)
}